// eslint-disable-next-line import/prefer-default-export
export const tryCatchHandlr = async (promise) => {
  try {
    const data = await promise;
    return [data, null];
  } catch (err) {
    return [null, err];
  }
};
